<template>
    <b-navbar-brand>
        <slot />
    </b-navbar-brand>
</template>

<script>
import { BNavbarBrand } from 'bootstrap-vue'

export default {
    components: { BNavbarBrand },
}
</script>